import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ServiceIDByLabel from "../../../services/ServiceIDByLabel";
import checkIfEnable from "../../../utils/checkIfEnable";
import TEXT from "../../../utils/globalText";
import "./index.css";
import SVGComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons/index.js";

const NavbarMenuPopover = ({ data, open, type, handleMenuItemClick }) => {
  const elementRef = useRef(null);
  const contentRef = useRef(null);
  const lastDataRef = useRef(data);

  const [renderType, setRenderType] = useState(
    type && type !== "initial" ? type : "transactions",
  );

  const services_list = useSelector((state) => state.refreshToken.services);
  const stableData = open ? data : lastDataRef.current;

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedThirdItem, setSelectedThirdItem] = useState(null);
  const [isRestoringState, setIsRestoringState] = useState(false);

  const lastValidCategory = useRef(null);
  const lastValidSubCategory = useRef(null);
  const lastValidThirdItem = useRef(null);

  if (selectedCategory) lastValidCategory.current = selectedCategory;
  if (selectedSubCategory) lastValidSubCategory.current = selectedSubCategory;
  if (selectedThirdItem) lastValidThirdItem.current = selectedThirdItem;

  const activeCategory = open ? selectedCategory : lastValidCategory.current;
  const activeSubCategory = open
    ? selectedSubCategory
    : lastValidSubCategory.current;
  const activeThirdItem = open ? selectedThirdItem : lastValidThirdItem.current;

  const services = useSelector((state) => state.refreshToken.services);

  const MENU_CONFIG = {
    transactions: {
      firstColumn: [
        {
          key: "payables",
          title: "Payables",
          subtitle: "Outgoing transactions",
        },
        // {
        //   key: "receivables",
        //   title: "Receivables",
        //   subtitle: "Incoming transactions",
        // },
        {
          key: "manage",
          title: "Allocations",
          subtitle: "Internal transfer",
        },
      ],

      secondColumnData: {
        payables: [
          {
            icon: ICONS?.BENEFICIARY_TRANSACTION_BLUE_CIRCLE,
            label: "Beneficiary",
            labelm: "Beneficiary",
            route: "beneficiary_transaction_dashboard",
            menu: "Transactions",
          },

          // {
          //   icon: ICONS?.REIMBURSEMENT_TRANSACTION_BLUE_CIRCLE,
          //   label: "Reimbursement",
          //   labelm: "Reimbursement",
          //   labela: "Transactions",
          //   route: "reimbursement_transaction_dashboard",
          //   menu: "Transactions",
          // },

          // {
          //   icon: ICONS?.PRIVATE_TRANSACTION_BLUE_CIRCLE,
          //   label: "Private",
          //   labelm: "Private",
          //   labela: "Transactions",
          //   route: "private_transaction_dashboard",
          //   menu: "Transactions",
          // },

          // {
          //   icon: ICONS?.FIELD_FORCE_TRANSACTION_BLUE_CIRCLE,
          //   label: "Field Force",
          //   labelm: "FieldForce",
          //   labela: "Transactions",
          //   route: "field_force_transaction_dashboard",
          //   menu: "Transactions",
          // },

          // {
          //   icon: ICONS?.TAX_TRANSACTION_WITH_BLUE_CIRCLE,
          //   label: "Tax",
          //   labelm: "Tax",
          //   labela: "Transactions",
          //   route: "tax_transaction_dashboard",
          //   menu: "Transactions",
          // },
        ],
        // receivables: [
        //   {
        //     icon: ICONS?.REIMBURSEMENT_TRANSACTION_BLUE_CIRCLE,
        //     label: "Reimbursement",
        //     labelm: "ReimbursementReq",
        //     route: "reimbursement_transaction_dashboard",
        //     menu: "Transactions",
        //   },
        //   {
        //     icon: ICONS?.FIELD_FORCE_TRANSACTION_BLUE_CIRCLE,
        //     label: "Field Force ",
        //     labelm: "FieldForceReq",
        //     route: "field_force_transaction_dashboard",
        //     menu: "Transactions",
        //   },
        // ],

        manage: [
          {
            icon: ICONS?.INTERNAL_TRANSACTION_BLUE_CIRCLE,
            label: "Internal",
            labelm: "Internal",
            route: "internal_transaction_dashboard",
            menu: "Transactions",
          },
        ],
      },

      thirdColumnData: {
        Beneficiary: [
          {
            label: "Dashboard",
            route: "/beneficiary_transaction_dashboard",
            userServices: "VBeneficiaryTxn",
          },
          {
            label: "Create transaction",
            route:
              "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
            userServices: "CBeneficiaryTxn",
          },
          {
            label: "View all transaction",
            route:
              "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all",
            userServices: "VBeneficiaryTxn",
          },
          {
            label: "Require approval",
            route:
              "/beneficiary_transaction_dashboard/beneficiary_transaction_single_approval",
            userServices: "ABeneficiaryTxn",
          },
        ],

        Reimbursement: [
          {
            label: "Dashboard",
            route: "/reimbursement_transaction_dashboard",
            userServices: "VReimbursementTxn",
          },
          {
            label: "Create transaction",
            route:
              "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
            userServices: "AReimbursementRequest, CReimbursementTxn",
          },
          {
            label: "View all transaction",
            route:
              "/reimbursement_transaction_dashboard/reimbursement_transaction_view_all",
            userServices: "VReimbursementTxn",
          },
          {
            label: "Require approval",
            route:
              "/reimbursement_transaction_dashboard/reimbursement_transaction_single_approval",
            userServices: "AReimbursementTxn",
          },
        ],

        Private: [
          {
            label: "Dashboard",
            route: "/private_transaction_dashboard",
            userServices: "VPrivateTransaction",
          },
          {
            label: "Create transaction",
            route: "/private_transaction_dashboard/create_private_transaction",
            userServices: "CPrivateTransaction",
          },
          {
            label: "View all transaction",
            route:
              "/private_transaction_dashboard/private_transaction_view_all",
            userServices: "VPrivateTransaction",
          },
          {
            label: "Require approval",
            route:
              "/private_transaction_dashboard/private_transaction_approval",
            userServices: "APrivateTransaction",
          },
        ],

        Internal: [
          {
            label: "Dashboard",
            route: "/internal_transaction_dashboard",
            userServices: "VInternalTxn",
          },
          {
            label: "Create transaction",
            route:
              "/internal_transaction_dashboard/create_internal_transaction",
            userServices: "CInternalTxn",
          },
          {
            label: "View all transaction",
            route:
              "/internal_transaction_dashboard/internal_transaction_view_all",
            userServices: "VInternalTxn",
          },
          {
            label: "Require approval",
            route:
              "/internal_transaction_dashboard/internal_transaction_single_approval",
            userServices: "AInternalTxn",
          },
        ],

        FieldForce: [
          {
            label: "Dashboard",
            route: "/field_force_transaction_dashboard",
            userServices: "VFieldForceTxn",
          },
          {
            label: "View all transaction",
            route:
              "/field_force_transaction_dashboard/field_force_transaction_view_all",
            userServices: "VFieldForceTxn",
          },
          {
            label: "Require approval",
            route:
              "/field_force_transaction_dashboard/field_force_transaction_single_approval",
            userServices: "AFieldForceTxn",
          },
        ],

        Tax: [
          {
            label: "Dashboard",
            route: "/tax_transaction_dashboard",
            userServices: "VTDSTransaction",
          },
          {
            label: "Create transaction",
            route: "/tax_transaction_dashboard/create_tax_transaction",
            userServices: "CTAXTransaction",
          },
          {
            label: "View all transaction",
            route: "/tax_transaction_dashboard/tax_transaction_view_all",
            userServices: "VTDSTransaction",
          },
          {
            label: "Require approval",
            route: "/tax_transaction_dashboard/tax_transaction_single_approval",
            userServices: "ATDSTransaction",
          },
        ],

        ReimbursementReq: [
          {
            label: "Create request",
            route:
              "/reimbursement_transaction_dashboard/create_reimbursement_request",
            userServices: "CReimbursementTxn",
          },
          {
            label: "View all request",
            route:
              "/reimbursement_transaction_dashboard/reimbursement_request_view_all",
            userServices: "VReimbursementTxn",
          },
          {
            label: "Require approval",
            route:
              "/reimbursement_transaction_dashboard/reimbursement_request_single_approval",
            userServices: "AReimbursementRequest",
          },
        ],

        FieldForceReq: [
          {
            label: "Create request",
            route:
              "/field_force_transaction_dashboard/create_field_force_request",
            userServices: "CFieldForceTxn",
          },
          {
            label: "View all request",
            route:
              "/field_force_transaction_dashboard/field_force_request_view_all",
            userServices: "VFieldForceTxn",
          },
          {
            label: "Require approval",
            route:
              "/field_force_transaction_dashboard/field_force_request_single_approval",
            userServices: "AFieldForceRequest",
          },
        ],
      },
    },

    accounts: {
      firstColumn: [
        {
          key: "payables",
          title: "Payables",
          subtitle: "Payables accounts",
        },
        {
          key: "manage",
          title: "Manage",
          subtitle: "Manage accounts",
        },
      ],

      secondColumnData: {
        payables: [
          {
            icon: ICONS?.BENEFICIARY_ACCOUNT_WITH_BLUE_CIRCLE,
            label: "Beneficiary",
            labelm: "Beneficiary",
            route: "beneficiary_account_dashboard",
            menu: "Accounts",
          },
          // {
          //   icon: ICONS?.REIMBURSEMENT_ACCOUNTS_WITH_BLUE_CIRCLE,
          //   label: "Reimbursement",
          //   labelm: "Reimbursement",
          //   labela: "Transactions",
          //   route: "reimbursement_account_dashboard",
          //   menu: "Accounts",
          // },
          // {
          // icon: ICONS?.FIELD_FORCE_ACCOUNTS_WITH_BLUE_CIRCLE,    // Please be mindful while rebasing
          //   label: "Field Force",
          //   labelm: "FieldForce",
          //   labela: "Transactions",
          //   route: "field_force_account_dashboard",
          //   menu: "Accounts",
          // },

          // {
          //   icon: ICONS?.TAX_ACCOUNTS_WITH_BLUE_CIRCLE,
          //   label: "Tax",
          //   labelm: "Tax",
          //   labela: "Transactions",
          //   route: "tax_account_dashboard",
          //   menu: "Accounts",
          // },
        ],

        receivables: [
          {
            icon: ICONS?.REMITTER_ACCOUNT_WITH_BLUE_CIRCLE,
            label: "Remitter",
            labelm: "Remitter",
            route: "remitter_account_dashboard",
            menu: "Accounts",
          },
        ],

        manage: [
          {
            icon: ICONS?.OWNER_ACCOUNT_WITH_BLUE_CIRCLE,
            label: "Owner",
            labelm: "Owner",
            route: "owner_account_dashboard",
            menu: "Accounts",
          },
          {
            icon: ICONS?.INTERNAL_ACCOUNT_WITH_BLUE_CIRCLE,
            label: "Internal",
            labelm: "Internal",
            route: "internal_account_dashboard",
            menu: "Accounts",
          },
        ],
      },

      thirdColumnData: {
        Beneficiary: [
          {
            label: "Dashboard",
            route: "/beneficiary_account_dashboard",
            userServices: "BVAccount",
          },
          {
            label: "Create account",
            route: "/beneficiary_account_dashboard/create_beneficiary_account",
            userServices: "BUAccount",
          },
          {
            label: "View all account",
            route:
              "/beneficiary_account_dashboard/beneficiary_account_view_all",
            userServices: "BVAccount",
          },
          ...(services?.includes("BAAccount") || services?.includes("Admin")
            ? [
                {
                  label: "Require approval",
                  route:
                    "/beneficiary_account_dashboard/beneficiary_account_approval",
                  userServices: "BAAccount",
                },
              ]
            : []),
        ],

        Reimbursement: [
          {
            label: "Dashboard",
            route: "/reimbursement_account_dashboard",
            userServices: "RVAccount",
          },
          {
            label: "Create account",
            route:
              "/reimbursement_account_dashboard/create_reimbursement_account",
            userServices: "RUAccount",
          },
          {
            label: "View all account",
            route:
              "/reimbursement_account_dashboard/reimbursement_account_view_all",
            userServices: "RVAccount",
          },
          ...(services?.includes("RAAccount") || services?.includes("Admin")
            ? [
                {
                  label: "Require approval",
                  route:
                    "/reimbursement_account_dashboard/reimbursement_account_approval",
                  userServices: "RAAccount",
                },
              ]
            : []),
        ],

        Internal: [
          {
            label: "Dashboard",
            route: "/internal_account_dashboard",
            userServices: "IVAccount",
          },
          {
            label: "View all account",
            route: "/internal_account_dashboard/internal_account_view_all",
            userServices: "IVAccount",
          },
          ...(services?.includes("IAAccount") || services?.includes("Admin")
            ? [
                {
                  label: "Require approval",
                  route:
                    "/internal_account_dashboard/internal_account_approval",
                  userServices: "IAAccount",
                },
              ]
            : []),
        ],

        Owner: [
          {
            label: "Dashboard",
            route: "/owner_account_dashboard",
            userServices: "VAccount",
          },

          {
            label: "View all account",
            route: "/owner_account_dashboard/owner_accounts_view_all",
            userServices: "VAccount",
          },
        ],

        FieldForce: [
          {
            label: "Dashboard",
            route: "/field_force_account_dashboard",
            userServices: "FFVAccount",
          },
          {
            label: "Create account",
            route: "/field_force_account_dashboard/create_field_force_account",
            userServices: "FFUAccount",
          },
          {
            label: "View all account",
            route:
              "/field_force_account_dashboard/field_force_account_view_all",
            userServices: "FFVAccount",
          },
          ...(services?.includes("FFAAccount") || services?.includes("Admin")
            ? [
                {
                  label: "Require approval",
                  route:
                    "/field_force_account_dashboard/field_force_account_approval",
                  userServices: "FFAAccount",
                },
              ]
            : []),
        ],

        Tax: [
          {
            label: "Dashboard",
            route: "/tax_account_dashboard",
            userServices: "VTDSAccount",
          },
          {
            label: "Create account",
            route: "/tax_account_dashboard/create_tax_account",
            userServices: "CTDSAccount",
          },
          {
            label: "View all account",
            route: "/tax_account_dashboard/tax_account_view_all",
            userServices: "VTDSAccount",
          },
          ...(services?.includes("BTDSAccount") || services?.includes("Admin")
            ? [
                {
                  label: "Require approval",
                  route: "/tax_account_dashboard/tax_account_approval",
                  userServices: "BTDSAccount",
                },
              ]
            : []),
        ],
      },
    },

    feature: {
      firstColumn: [
        {
          key: "reconciliation",
          title: "Reconciliation",
          subtitle: "Match accounts to credit entries",
        },
      ],

      secondColumnData: {
        reconciliation: [
          {
            icon: ICONS?.REMITTER_ACCOUNT_WITH_BLUE_CIRCLE,
            label: "Remitter",
            labelm: "Remitter",
            route: "remitter_account_dashboard",
            menu: "Accounts",
          },
        ],
      },
      thirdColumnData: {
        Remitter: [
          {
            label: "Dashboard",
            route: "/remitter_account_dashboard",
            userServices: "REVAccount",
          },
          {
            label: "Create account",
            route: "/remitter_account_dashboard/create_remitter_account",
            userServices: "REUAccount",
          },
          {
            label: "View all account",
            route: "/remitter_account_dashboard/remitter_account_view_all",
            userServices: "REVAccount",
          },
          ...(services?.includes("REAAccount") || services?.includes("Admin")
            ? [
                {
                  label: "Require approval",
                  route:
                    "/remitter_account_dashboard/remitter_account_approval",
                  userServices: "REAAccount",
                },
              ]
            : []),
          // {
          //   label: "Match in bank statement",
          //   route: "/owner_account_dashboard/consolidated_bank_statement",
          //   userServices: "VAccountBalance",
          // },
          // {
          //   label: "Match in live statement",
          //   route: "/owner_account_dashboard/consolidated_live_statement",
          //   userServices: "VItemisedStatement",
          // },
        ],
      },
    },
  };

  const currentMenu = MENU_CONFIG[renderType] || {};

  const firstColumn = currentMenu.firstColumn || [];
  const secondColumnData = currentMenu.secondColumnData || {};
  const thirdColumnData = currentMenu.thirdColumnData || {};

  const secondColumn = secondColumnData[activeCategory?.key] || [];
  const thirdColumn = thirdColumnData[activeSubCategory?.labelm] || [];

  const activeServiceLabel = activeSubCategory
    ? `${activeSubCategory.label} ${activeSubCategory.menu}`
    : "";

  const activeHasServiceMapping = ServiceIDByLabel[activeServiceLabel];

  const isActiveSubCategoryEnabled = activeHasServiceMapping
    ? checkIfEnable(ServiceIDByLabel, activeServiceLabel, services_list)
    : true;

  useEffect(() => {
    if (type && type !== "initial" && type !== "none") {
      setRenderType(type);
    }
  }, [type]);

  useEffect(() => {
    if (!open) {
      return;
    }

    setIsRestoringState(true);
    const currentPath = window.location.pathname;

    let matchedCategory = null;
    let matchedSubCategory = null;
    let matchedThirdItem = null;

    const currentCategoryData = secondColumnData;
    let foundMatch = false;

    Object.entries(currentCategoryData).forEach(
      ([categoryKey, secondItems]) => {
        secondItems.forEach((secondItem) => {
          const route = secondItem.route ? `/${secondItem.route}` : "";
          if (route === currentPath) {
            if (matchedSubCategory && selectedCategory?.key === categoryKey) {
              return;
            }
            matchedSubCategory = secondItem;
            matchedCategory = firstColumn.find((fc) => fc.key === categoryKey);
            foundMatch = true;
          }
        });
      },
    );

    if (!foundMatch) {
      Object.entries(thirdColumnData).forEach(
        ([subCategoryKey, thirdItems]) => {
          thirdItems.forEach((thirdItem) => {
            if (thirdItem.route === currentPath) {
              matchedThirdItem = thirdItem;
              Object.entries(currentCategoryData).forEach(
                ([categoryKey, secondItems]) => {
                  secondItems.forEach((secondItem) => {
                    if (secondItem.labelm === subCategoryKey) {
                      if (
                        matchedSubCategory &&
                        selectedCategory?.key === categoryKey
                      ) {
                        return;
                      }
                      matchedSubCategory = secondItem;
                      matchedCategory = firstColumn.find(
                        (fc) => fc.key === categoryKey,
                      );
                      foundMatch = true;
                    }
                  });
                },
              );
            }
          });
        },
      );
    }

    if (
      currentPath === "/reimbursement_transaction_dashboard" ||
      currentPath === "/field_force_transaction_dashboard"
    ) {
      if (
        selectedCategory &&
        (selectedCategory.key === "payables" ||
          selectedCategory.key === "receivables")
      ) {
        matchedCategory = selectedCategory;
        const explicitSecondList = secondColumnData[selectedCategory.key] || [];
        const accurateSub = explicitSecondList.find(
          (item) => `/${item.route}` === currentPath,
        );
        if (accurateSub) {
          matchedSubCategory = accurateSub;
        }
      }
    }

    if (matchedCategory && matchedSubCategory) {
      setSelectedCategory(matchedCategory);
      setSelectedSubCategory(matchedSubCategory);
      setSelectedThirdItem(matchedThirdItem);
    } else {
      const defaultCategory = firstColumn[0] || null;
      setSelectedCategory(defaultCategory);
      const defaultSecond = secondColumnData[defaultCategory?.key]?.[0] || null;
      setSelectedSubCategory(defaultSecond);
      setSelectedThirdItem(null);
    }

    const timer = setTimeout(() => {
      setIsRestoringState(false);
    }, 150);

    return () => clearTimeout(timer);
  }, [open, renderType]);

  useEffect(() => {
    if (!selectedCategory || !open) return;
    const availableSecondColumn = secondColumnData[selectedCategory.key] || [];
    const currentStillExists = availableSecondColumn.some(
      (item) => item.label === selectedSubCategory?.label,
    );

    if (!currentStillExists) {
      setSelectedSubCategory(availableSecondColumn[0] || null);
      setSelectedThirdItem(null);
    }
  }, [selectedCategory, open]);

  useLayoutEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    if (open) {
      el.style.height = "var(--navbar-popup-height)";
      el.style.maxHeight =
        "calc(var(--full-height) - var(--navbar-height) - var(--padding-md))";
    } else {
      el.style.height = "var(--height-base)";
      el.style.maxHeight = "";
    }
  }, [open]);

  return (
    <div
      ref={elementRef}
      className={`absolute top-top-almost-full left-left-half translate-x-byok-line-translate z-z-index-max
      transition-all duration-300 ease-in-out origin-top shadow-box-shadow-navbar rounded-border-radius-md
      ${
        open
          ? "opacity-100 pointer-events-auto visibility-visible"
          : "opacity-0 pointer-events-none visibility-hidden"
      }
    `}
    >
      <div
        ref={contentRef}
        className="content-section bg-text-primary border border-gray-100 flex flex-col overflow-hidden rounded-border-radius-md gap-top_sm shadow-box-shadow-navbar min-w-navbar-min-width max-w-navbar-max-width Qlg:w-navbar-width transition-all duration-300 ease-in-out"
      >
        <div className="flex flex-row flex-1 min-h-0 overflow-hidden">
          <div className="flex-1 min-h-0 p-padding-sm">
            {firstColumn?.map((item, index) => {
              const isActive = activeCategory?.key === item.key;

              return (
                <div
                  key={item.key || index}
                  onMouseEnter={() => {
                    if (isRestoringState || !open) return;
                    setSelectedCategory(item);
                  }}
                  onClick={() => {
                    if (!open) return;
                    setSelectedCategory(item);
                  }}
                  className={`py-padding-sm px-padding-md m-margin-md flex flex-row items-center justify-between rounded-border-radius-l
                  ${isActive ? "bg-primary-act bg-opacity-40 " : " "}`}
                >
                  <div className="flex flex-col font-normal gap-y-gap-xs">
                    <div className="text-font-md text-primary-bg">
                      {item.title}
                    </div>
                    <div className="text-font-xs text-primary-act">
                      {item.subtitle}
                    </div>
                  </div>

                  <div className="flex-shrink-0">
                    <SVGComponent
                      url={ICONS?.ARROW_RIGHT_WHITE}
                      width="var(--icon-sm)"
                      height="var(--icon-sm)"
                      color="var(--primary-bg)"
                    />
                  </div>
                </div>
              );
            })}
          </div>

          <div className="border-border border-solid border-text-secondary mt-margin-sm self-stretch flex-shrink-0"></div>

          <div className="flex-1 min-h-0 overflow-y-auto p-padding-sm">
            {secondColumn?.map((item, index) => {
              const isActive = activeSubCategory?.label === item.label;
              const serviceLabel = `${item.label} ${item.menu}`;
              const hasServiceMapping = ServiceIDByLabel[serviceLabel];
              const isEnabled = hasServiceMapping
                ? checkIfEnable(ServiceIDByLabel, serviceLabel, services_list)
                : true;

              return (
                <div
                  key={item.label || index}
                  onMouseEnter={() => {
                    if (isRestoringState || !open) return;
                    setSelectedSubCategory(item);
                    setSelectedThirdItem(null);
                  }}
                  onClick={() => {
                    if (!open) return;
                    setSelectedThirdItem(null);
                    handleMenuItemClick(item.route);
                  }}
                  className={`p-padding-sm m-margin-md flex flex-row items-center justify-between gap-gap-sm rounded-border-radius-l
                 ${isEnabled ? "cursor-pointer" : "cursor-not-allowed opacity-light-opacity"} 
                 ${isActive ? "bg-primary-act bg-opacity-20 " : ""}`}
                >
                  <div className="flex flex-row items-center Qsmd:gap-x-gap-xs Qlg:gap-x-gap-md">
                    {item.icon && (
                      <img
                        className="w-icon-lg h-icon-lg"
                        src={item.icon}
                        alt=""
                      />
                    )}
                    <div className="text-font-md text-primary-bg">
                      {item.label}
                    </div>
                  </div>

                  <div>
                    <SVGComponent
                      url={ICONS?.ARROW_RIGHT_WHITE}
                      width="var(--icon-sm)"
                      height="var(--icon-sm)"
                      color="var(--primary-bg)"
                    />
                  </div>
                </div>
              );
            })}
          </div>

          <div className="border-border border-solid border-text-secondary mt-margin-sm self-stretch flex-shrink-0"></div>

          <div className="flex-1 min-h-0 overflow-y-auto p-padding-sm">
            {thirdColumn?.map((item, index) => {
              const isActive =
                activeThirdItem?.label === item.label ||
                (!activeThirdItem && item.route === window.location.pathname);

              const requiredServices = item.userServices
                ?.split(",")
                .map((s) => s.trim());

              const isEnabled = !isActiveSubCategoryEnabled
                ? false
                : requiredServices
                  ? item.userServices ===
                    "AReimbursementRequest, CReimbursementTxn"
                    ? requiredServices.every((service) =>
                        services_list?.includes(service),
                      )
                    : requiredServices.some((service) =>
                        services_list?.includes(service),
                      )
                  : true;

              return (
                <div
                  key={item.label || index}
                  onClick={() => {
                    if (!open) return;
                    setSelectedThirdItem(item);
                    handleMenuItemClick(item.route);
                    if (
                      item.route ===
                      "/beneficiary_transaction_dashboard/create_beneficiary_transaction"
                    ) {
                      sessionStorage.removeItem("recreate_ben");
                    }
                    if (
                      item.route ===
                      "/internal_transaction_dashboard/create_internal_transaction"
                    ) {
                      sessionStorage.removeItem("recreate_int_txn_id");
                    }
                  }}
                  className={`px-padding-sm rounded-border-radius-l py-padding-l m-margin-md font-normal flex flex-row items-center justify-between text-font-md
      ${isEnabled ? "cursor-pointer hover:bg-primary-act hover:bg-opacity-20" : "cursor-not-allowed opacity-light-opacity"} 
      ${isActive ? "bg-primary-act bg-opacity-20" : ""}`}
                >
                  <div className="text-font-md text-primary-bg">
                    {item.label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="h-message-height flex-shrink-0 flex items-center bg-gray-50/80 py-padding-sm px-padding-md">
          <p className="text-font-xxs text-text-disabled">
            {TEXT?.NAVBAR_WARNING ||
              "*If disabled - the feature is not available for your ID."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NavbarMenuPopover;
